var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_vm._l((_vm.children),function(student,index){return _c('v-col',{key:index,attrs:{"cols":"12","xs":"12","sm":"6","md":"4","lg":"3"}},[_c('ScheduleCard',{attrs:{"student":student}})],1)}),(_vm.isLoading)?_c('ProgressCircular'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }